import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDto } from '../api/models';

const SESSION_ID='versus.session';
const TOKEN_ID='versus.session.token';
@Injectable({
  providedIn: 'root'
})
export class SessionService {


   private _message:string;

   userInfo:any;
  constructor() {
    this._message='';
   }

   getToken ():string{
    let guid = localStorage.getItem(TOKEN_ID);
    return  guid||'';
   }
   setToken(token:string){
    console.log('save token')
    console.log(token);
    localStorage.setItem(TOKEN_ID, token);
    console.log('saved token');
   }
   get message(){
    return this.message;
   }
   set message(mess:string){
    this._message=mess;
   }
   handleError (err:HttpErrorResponse){
    this.message=err.error.message;
   }

   setSessionInfo(sess: UserDto) {
    localStorage.setItem(SESSION_ID, JSON.stringify(sess));
  }
  getSessionInfo():UserDto{
    let gui =localStorage.getItem(SESSION_ID);
    return gui? JSON.parse(gui):{};
  }
  isConnected():boolean{
    
    return this.getToken().length>0;
  }
  deleteSession(){
    localStorage.removeItem(TOKEN_ID);
    localStorage.removeItem(SESSION_ID);
  }
  
}
